import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { request } from "@/js/http/http_request";
import { regExpMail } from "@/js/regexp_validation.js";
import Error from "@/views/error/error.vue";
import { resetPasswordErrors } from "@/js/lists.ts";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "resetPassword",
  components: {
    Error: Error,
    BackgroundVideo: BackgroundVideo
  },
  data: function data() {
    return {
      isReseting: false,
      mailError: "",
      resetDone: false,
      serverError: false,
      input: {
        mail: ""
      },
      errorMessages: {
        mail: {
          empty: "This field is required",
          format: "Incorrect format, valid email address expected",
          server: "An error occured, please contact an administrator"
        },
        error: {
          title: "",
          linkTitle: "",
          description: ""
        }
      },
      resetPasswordErrors: resetPasswordErrors
    };
  },
  methods: {
    reset: function reset() {
      if (this.validateDatas()) {
        var _this = this;
        var data = {
          mail: _this.input.mail,
          client_id: _this.$whitelabel.clientId,
          client_secret: _this.$whitelabel.clientSecret
        };
        _this.isReseting = true;
        request("/v1/account/request-reset", "post", data, false, "api").then(function (response) {
          _this.isReseting = false;
          _this.resetDone = true;
          if (response.status != 200) {
            _this.serverError = true;
          }
        }).catch(function (err) {
          var _err$response;
          _this.isReseting = false;
          _this.resetDone = true;
          _this.serverError = true;
          if (err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.data) {
            var messageObject = resetPasswordErrors[err.response.data.value];
            if (messageObject) {
              _this.errorMessages.error = messageObject;
            } else {
              _this.errorMessages.error = {
                title: "Error ",
                linkTitle: "Home",
                description: "An error occured."
              };
            }
          }
        });
      }
    },
    validateDatas: function validateDatas() {
      this.mailError = "";
      if (!this.input.mail) {
        this.mailError = this.errorMessages.mail.empty;
      } else if (!regExpMail.test(this.input.mail)) {
        this.mailError = this.errorMessages.mail.format;
      }
      if (!!this.mailError) {
        return false;
      }
      return true;
    },
    home: function home() {
      this.$router.push({
        name: "home"
      });
    }
  }
};